import { type ReactNode } from 'react'

/**
 * T-M: マーケティング 3 ページ (#landing / #docs / #contact) 用 Shell。
 *
 * AuthLayout と違い、`data-shell="marketing"` を付けて theme.css の
 * `.app[data-shell=...]` グリッド (1 列) を流用するが、内側でページ自身が
 * `<header>` / `<main>` / `<footer>` を完全制御する full-bleed レイアウト。
 *
 * Sidenav / Topbar / RouteGuard は持たない (公開ページなので)。
 */
export interface MarketingLayoutProps {
  children: ReactNode
}

export const MarketingLayout = ({ children }: MarketingLayoutProps): JSX.Element => (
  <div className="app" data-shell="marketing">
    <main className="main marketing-main">{children}</main>
  </div>
)
